import React from "react";
import "./interests-section.styles.css";

const TECH_ITEMS = [
  {
    title: "Java & Spring",
    category: "Backend",
    label: "Core",
    description:
      "My primary stack for building enterprise-grade distributed systems — from microservices and event-driven architectures to multi-tenant SaaS platforms.",
    link: "https://spring.io/",
    featured: true,
  },
  {
    title: "Kubernetes & Docker",
    category: "DevOps",
    label: "Cloud",
    description:
      "Container orchestration and cloud-native deployment — Helm charts, GCP Cloud Functions, and multi-cloud replication pipelines.",
    link: "https://kubernetes.io/",
  },
  {
    title: "AI & MCP Agents",
    category: "Emerging",
    label: "Tools",
    description:
      "Building MCP servers and AI agents that connect LLMs to real-world tools — stock analysis, automation, and intelligent workflows.",
    link: "https://github.com/pvyas033/stockanalyzer",
  },
  {
    title: "React & Web",
    category: "Frontend",
    label: "UI",
    description:
      "Crafting interactive web experiences — from e-commerce storefronts to portfolio sites and data visualization dashboards.",
    link: "https://pvyas033.github.io/crwn-clothing/",
  },
];

const InterestsSection = () => (
  <section className="me-section">
    <div className="me-title-wrapper">
      <h2 className="h2">I build with</h2>
    </div>
    <div className="show-container">
      {TECH_ITEMS.map((item) => (
        <div key={item.title} className={`show-cell ${item.featured ? "" : ""}`}>
          <div className="show">
            <a href={item.link} target="_blank" rel="noreferrer" className="show-poster">
              <div className="tag">
                {item.featured && (
                  <div className="favorite-star">
                    <svg width="32" height="32" viewBox="0 0 155 162" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M77.0352 0L82.0412 65.5929L124.646 15.4696L90.1412 71.4779L154.071 55.9696L93.2352 81L154.071 106.03L90.1412 90.5221L124.646 146.53L82.0412 96.4071L77.0352 162L72.0291 96.4071L29.4245 146.53L63.9291 90.5221L0 106.03L60.8352 81L0 55.9696L63.9291 71.4779L29.4245 15.4696L72.0291 65.5929L77.0352 0Z" fill="#FFD177"/>
                    </svg>
                  </div>
                )}
                {item.featured && <div className="c label y">Pankaj's<br/>favorite</div>}
              </div>
            </a>
            <div className="content-title-wrapper me">
              <div className="content-title-group">
                <div className="h4"><strong>{item.title}</strong></div>
                <div className="h4 gold">{item.category}</div>
              </div>
              <div className="label gold">
                <div className="c label gold">{item.label}</div>
              </div>
            </div>
          </div>
          <div className="show-review">
            <div className="b2 m500">{item.description}</div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default InterestsSection;
